import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    forgotContainer: {
      textAlign: 'right',
      '& p': {
        fontSize: 13,
      },
    },
    registerBox: {
      color: theme.palette.primary.contrastText,
      '& p': {
        marginBottom: 5,
      },
      '& a': {
        fontSize: 16,
        fontWeight: 'bold',
        textDecoration: 'underline',
      },
    },
    h1n1Button: {
      borderRadius: 15,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundImage: 'linear-gradient(to right, #E882C4 0%, #E4008B 100%)',
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'none',
      color: theme.palette.primary.contrastText,
      maxWidth: 440,
    },
  })
);

export default useStyles;
